var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { APPLICATION } from '../../../config/routes';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { services, tryParseInt, formTypeName } from '../../../shared';
import { Button, CtaBar, Icon } from '../../shared';
import { FormType } from '../../../shared/types/enums';
import { Dialog } from '../../shared';
import { useWorkflowStore } from '../../store/workflowStore';
import { useAppSelector } from '../../app/hooks';
export var CaseNavigation = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var pages = _a.pages, location = _a.location, setTargetPage = _a.setTargetPage, workflowSteps = _a.workflowSteps, nextDisabled = _a.nextDisabled, onNextClick = _a.onNextClick, useFormSubmit = _a.useFormSubmit, nextPageStep = _a.nextPageStep, currentSectionId = _a.currentSectionId;
    var _j = useParams(), sectionId = _j.sectionId, caseId = _j.caseId, loanPurposeId = _j.loanPurposeId, formId = _j.formId;
    var _k = useState(), nextPage = _k[0], setNextPage = _k[1];
    var _l = useState(), previousPage = _l[0], setPreviousPage = _l[1];
    var _m = useState(false), isLastPage = _m[0], setLastPage = _m[1];
    var history = useHistory();
    var completionStage = 'Complete Full Mortgage Application';
    var currentCase = (_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : Number(caseId);
    var caseLoanPurpose = (_f = (_e = location === null || location === void 0 ? void 0 : location.state) === null || _e === void 0 ? void 0 : _e.loanPurposeId) !== null && _f !== void 0 ? _f : Number(loanPurposeId);
    var _o = useState(true), isIllustrationEnabled = _o[0], setIsIllustrationEnabled = _o[1];
    var _p = useState(false), showModal = _p[0], setShowModal = _p[1];
    var removeWorkflow = useWorkflowStore(function (state) { return state.removeWorkflowStore; });
    var _q = useState(false), isLoading = _q[0], setIsLoading = _q[1];
    var isAdmin = useAppSelector(function (state) { return state.adminData.adminData.isAdmin; });
    var triggerNextPage = function () {
        var _a;
        if (((_a = nextPage === null || nextPage === void 0 ? void 0 : nextPage.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'submit') {
            var currentForm = workflowSteps === null || workflowSteps === void 0 ? void 0 : workflowSteps.find(function (step) { return step.isActive; });
            if ((currentForm === null || currentForm === void 0 ? void 0 : currentForm.formType) == FormType[FormType.Illustration].toString()) {
                services.submitApplication(currentCase, currentForm.formId).then(function () {
                    removeWorkflow();
                    history.push(nextPage.path, location.state);
                });
            }
            else {
                history.push(nextPage.path, location.state);
            }
        }
        else {
            history.push(nextPage.path, location.state);
        }
    };
    var pushNextPage = function (page) {
        setNextPage(nextPageStep !== null && nextPageStep !== void 0 ? nextPageStep : page);
        if (setTargetPage)
            setTargetPage(page);
    };
    var manageNextLink = function (currentPage, currentStep, pagesList) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (currentPage < pagesList.length - 1) {
            if (((_a = workflowSteps[currentStep]) === null || _a === void 0 ? void 0 : _a.formTypeId) == 3 && currentPage == pagesList.length - 2) {
                var returnPage = pagesList[currentPage + 1];
                returnPage.name = 'Generate Illustration';
                pushNextPage(returnPage);
            }
            else {
                pushNextPage(pagesList[currentPage + 1]);
            }
        }
        else {
            var nextForm = (_c = (_b = workflowSteps[currentStep + 1]) === null || _b === void 0 ? void 0 : _b.formId) !== null && _c !== void 0 ? _c : Number(formId);
            if (currentStep < workflowSteps.length - 1 && nextForm != 0) {
                var applicationId = tryParseInt((_f = (_e = (_d = location === null || location === void 0 ? void 0 : location.state) === null || _d === void 0 ? void 0 : _d.case) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : caseId);
                (applicationId.hasValue && ((_g = workflowSteps[currentStep + 1]) === null || _g === void 0 ? void 0 : _g.formType) == formTypeName.illustration
                    ? services.getPagesWithStatus(applicationId.value, nextForm)
                    : services.getPages(nextForm)).then(function (result) {
                    var _a, _b, _c;
                    if (result) {
                        pushNextPage(createNavPage(workflowSteps[currentStep + 1], result.data[0], ((_b = (_a = result.data[0]) === null || _a === void 0 ? void 0 : _a.sections) !== null && _b !== void 0 ? _b : [])[0], "".concat(((_c = workflowSteps[currentStep + 1]) === null || _c === void 0 ? void 0 : _c.isComplete) ? 'View' : 'Start', " ").concat(workflowSteps[currentStep + 1].formType)));
                    }
                });
            }
            else if (isLastPage) {
                pushNextPage({
                    sectionId: 0,
                    pageId: 0,
                    path: "".concat(APPLICATION.paths[0], "/").concat(currentCase, "/").concat(caseLoanPurpose, "/Complete"),
                    name: completionStage,
                });
            }
        }
    };
    var managePreviousLink = function (currentPage, currentStep, pagesList) {
        var _a, _b;
        if (currentPage == 0) {
            if (((_a = workflowSteps[currentStep - 1]) === null || _a === void 0 ? void 0 : _a.formId) == 0) {
                setPreviousPage(null);
            }
            else {
                services.getPages((_b = workflowSteps[currentStep - 1]) === null || _b === void 0 ? void 0 : _b.formId).then(function (result) {
                    var _a, _b, _c;
                    if (result && result.data) {
                        var page = result.data[result.data.length - 1];
                        setPreviousPage(createNavPage(workflowSteps[currentStep - 1], page, page === null || page === void 0 ? void 0 : page.sections[((_a = page === null || page === void 0 ? void 0 : page.sections) === null || _a === void 0 ? void 0 : _a.length) - 1], "View ".concat((_c = (_b = workflowSteps[currentStep - 1]) === null || _b === void 0 ? void 0 : _b.formType) !== null && _c !== void 0 ? _c : '')));
                    }
                });
            }
        }
        else {
            setPreviousPage(pagesList[currentPage - 1]);
        }
    };
    var createNavPage = function (step, page, section, name) {
        var _a, _b;
        return {
            sectionId: (_a = section === null || section === void 0 ? void 0 : section.id) !== null && _a !== void 0 ? _a : 0,
            pageId: page.id,
            path: section
                ? "".concat(APPLICATION.paths[0], "/").concat(currentCase, "/").concat(caseLoanPurpose, "/").concat(step === null || step === void 0 ? void 0 : step.formId, "/").concat(page.id, "/").concat(section.id)
                : "".concat(APPLICATION.paths[0], "/").concat(currentCase, "/").concat(caseLoanPurpose, "/").concat(step === null || step === void 0 ? void 0 : step.formId, "/").concat(page.name),
            status: page.applicationSectionStatus,
            name: (_b = name !== null && name !== void 0 ? name : section === null || section === void 0 ? void 0 : section.name) !== null && _b !== void 0 ? _b : page.name,
        };
    };
    var checkIsIllustrationEnabled = function () { return __awaiter(void 0, void 0, void 0, function () {
        var splitPath, name, esisDetails, productDetails;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    splitPath = history.location.pathname.split('/');
                    name = splitPath[splitPath.length - 1];
                    if (!(name == 'Fees')) return [3 /*break*/, 5];
                    return [4 /*yield*/, services.getEsisSummary(Number(caseId), Number(formId))];
                case 1: return [4 /*yield*/, (_e.sent()).data];
                case 2:
                    esisDetails = _e.sent();
                    return [4 /*yield*/, services.getAllProductDetails((_b = (_a = esisDetails[0]) === null || _a === void 0 ? void 0 : _a.productId) !== null && _b !== void 0 ? _b : 0, caseLoanPurpose)];
                case 3: return [4 /*yield*/, (_e.sent()).data];
                case 4:
                    productDetails = _e.sent();
                    if (!!esisDetails[0] && !!((_c = productDetails[0]) === null || _c === void 0 ? void 0 : _c.isIllustrationEnabled)) {
                        setIsIllustrationEnabled(true);
                    }
                    if (!!esisDetails[0] && !((_d = productDetails[0]) === null || _d === void 0 ? void 0 : _d.isIllustrationEnabled)) {
                        setIsIllustrationEnabled(false);
                    }
                    _e.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submitWithoutIllustration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentForm, step, redirectUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentForm = workflowSteps === null || workflowSteps === void 0 ? void 0 : workflowSteps.find(function (step) { return step.isActive; });
                    if (!showModal) return [3 /*break*/, 3];
                    return [4 /*yield*/, services.UpdateFeePageViewed(Number(caseId), Number(formId))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, services.submitApplication(Number(caseId), Number(formId))];
                case 2:
                    _a.sent();
                    if ((nextPage === null || nextPage === void 0 ? void 0 : nextPage.name) == 'Generate Illustration') {
                        step = workflowSteps[workflowSteps.findIndex(function (element) {
                            return element.formType.includes(FormType[FormType.Illustration].toString());
                        }) + 1];
                        redirectUrl = window.location.origin +
                            window.location.pathname
                                .split('/')
                                .slice(0, window.location.pathname.split('/').length - 2)
                                .join('/') +
                            '/' +
                            step.formId;
                        window.location.href = redirectUrl;
                    }
                    return [2 /*return*/];
                case 3:
                    if ((currentForm === null || currentForm === void 0 ? void 0 : currentForm.formType) == FormType[FormType.Illustration].toString() && !isIllustrationEnabled) {
                        setShowModal(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getCurrentFormType = function () {
        var currentForm = workflowSteps === null || workflowSteps === void 0 ? void 0 : workflowSteps.find(function (step) { return step.isActive; });
        return currentForm === null || currentForm === void 0 ? void 0 : currentForm.formType;
    };
    var hideModal = function () {
        setShowModal(false);
    };
    useEffect(function () {
        checkIsIllustrationEnabled();
    }, []);
    useEffect(function () {
        if (workflowSteps) {
            var currentStep_1 = workflowSteps.findIndex(function (step) { return step.isActive; });
            var splitPath = history.location.pathname.split('/');
            var name_1 = splitPath[splitPath.length - 1];
            var pagesList = pages.flatMap(function (page) {
                var _a, _b;
                return (_b = (_a = page.sections) === null || _a === void 0 ? void 0 : _a.map(function (section) {
                    return createNavPage(workflowSteps[currentStep_1], page, section);
                })) !== null && _b !== void 0 ? _b : [createNavPage(workflowSteps[currentStep_1], page)];
            });
            var currentPage = pagesList.findIndex(function (record) {
                return (record === null || record === void 0 ? void 0 : record.sectionId) == Number(sectionId ? sectionId : !currentSectionId ? name_1 : currentSectionId) ||
                    (record === null || record === void 0 ? void 0 : record.name.toLowerCase()) == name_1.toLowerCase();
            });
            currentPage = currentPage < 0 ? 0 : currentPage;
            if ((pagesList === null || pagesList === void 0 ? void 0 : pagesList.length) > 0 && (pages === null || pages === void 0 ? void 0 : pages.length) > 0) {
                setLastPage(pagesList[currentPage + 1] == null);
                managePreviousLink(currentPage, currentStep_1, pagesList);
                manageNextLink(currentPage, currentStep_1, pagesList);
            }
        }
    }, [pages, workflowSteps, caseId, isLastPage]);
    var generateLoader = function () {
        setIsLoading(true);
        onNextClick();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { modalType: "Info", show: showModal, handleClose: hideModal, modalTitle: "Continue without an illustration?", message: "This product does not have an illustration available. You may still progress or return and select an alternate product.", submit: submitWithoutIllustration, closeButtonText: "Cancel", yesButtonText: "Submit", showYesButton: true }),
        React.createElement(CtaBar, null,
            previousPage && (React.createElement(Link, { to: {
                    pathname: previousPage.path,
                    state: location === null || location === void 0 ? void 0 : location.state,
                }, className: "c-btn c-btn--outline c-btn--icon-left" },
                React.createElement(Icon, { name: "arrowLeft" }),
                React.createElement("span", { className: "c-question-set__previous-question" }, previousPage.name),
                React.createElement("span", { className: "c-question-set__previous" }, "Previous"))),
            pages && nextPage && (React.createElement(Button, { type: useFormSubmit ? 'submit' : 'button', variant: 'primary', loadingBar: isLoading ? true : false, icon: !isLoading ? 'arrowRight' : undefined, iconPosition: "right", childClasses: "c-form-submission", onClick: useFormSubmit
                    ? null
                    : (_g = (!isIllustrationEnabled && getCurrentFormType() === FormType[FormType.Illustration].toString()
                        ? submitWithoutIllustration
                        : ((nextPage === null || nextPage === void 0 ? void 0 : nextPage.name) == 'Generate Illustration') ? generateLoader : onNextClick)) !== null && _g !== void 0 ? _g : triggerNextPage, disabled: nextDisabled || isLoading || (isAdmin === true && ((_h = nextPage === null || nextPage === void 0 ? void 0 : nextPage.name) === null || _h === void 0 ? void 0 : _h.toLowerCase()) == 'submit') || (isAdmin === true && (nextPage === null || nextPage === void 0 ? void 0 : nextPage.name) == 'Generate Illustration') },
                React.createElement("span", { className: "c-question-set__next-question" }, !isLoading ? nextPage.name : 'Generating...'),
                React.createElement("span", { className: "c-question-set__next" }, "Next"))))));
};
